// extracted by mini-css-extract-plugin
module.exports = {"root":"CardReaderDesc_root__3SfcJ","col":"CardReaderDesc_col__1dITm","label":"CardReaderDesc_label__3nHK4"};